//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Column, Fields, Part, TitleSection } from "components/styles";
//#endregion
//#region Components
import HandlerRadio from "components/CustomRadio/CustomRadio";
import useEventFormContext from "views/Eventos/components/FormCreateEvent/ManualLoadingForm/utils/context/useEventFormContext";
//#endregion

const Part2_1 = ({ form, changeField, errors }) => {
	const { data } = useEventFormContext();
	const { complementaryServiceAreas } = data;
	const [
		filteredComplementaryServiceAreas,
		setFilteredComplementaryServiceAreas,
	] = useState([]);
	useEffect(() => {
		const filtered = complementaryServiceAreas
			.filter(({ eventTypeId }) => eventTypeId === form.eventTypeId)
			.map(({ id: value, name: label }) => ({
				value,
				label,
			}));
		setFilteredComplementaryServiceAreas(filtered);
	}, [form.eventTypeId]);
	const changeComplementaryServiceAreaId = value => {
		changeField("complementaryServiceAreaId", value, false);
	};
	return (
		<Part paddingBottom="10px">
			<Fields>
				<Column gap="30px">
					<TitleSection>Área de servicio complementario</TitleSection>
					<HandlerRadio
						value={form.complementaryServiceAreaId}
						onChange={changeComplementaryServiceAreaId}
						radiosProps={filteredComplementaryServiceAreas}
						error={errors.complementaryServiceAreaId}
						errorText="Recuerda que debes seleccionar una opción."
					/>
				</Column>
			</Fields>
		</Part>
	);
};

export default Part2_1;
